import _get from 'lodash/get';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _startCase from 'lodash/startCase';
import _cloneDeep from 'lodash/cloneDeep';

import initialState from './initialState';
import actionType from './actionTypes';

const BLOCDATAEXPLORERReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_BLOCDATAEXPLORER_RECORDS_SUCCESS: {
            const { tableName, columns, records, columnDefinitions, contextMenuItems } = action.payload;
            return {
                ...state,
                columnDefinitions,
                goldenDataColumns: columns,
                tableName,
                goldenDataRecords: records,
                contextMenuItems,
            };
        }
        case actionType.GET_SOURCEDATAEXPLORER_RECORDS_SUCCESS: {
            const { tableName, columns, records, columnDefinitions, contextMenuItems } = action.payload;
            return {
                ...state,
                columnDefinitions,
                sourceDataColumns: columns,
                tableName,
                sourceDataRecords: records,
                contextMenuItems,
            };
        }
        case actionType.GET_BLOCDATAEXPLORER_RECORDS_FAILURE:
            return {
                ...state,
                goldenDataRecords: [],
                gridOptions: {
                    ...state.gridOptions,
                    goldenDataColumns: [],
                },
            };
        case actionType.GET_SOURCEDATAEXPLORER_RECORDS_FAILURE:
            return {
                ...state,
                sourceDataRecords: [],
                gridOptions: {
                    ...state.gridOptions,
                    sourceDataColumns: [],
                },
            };
        case actionType.GET_ALL_BLOCDATAEXPLORER_NAMES_SUCCESS:
            return {
                ...state,
                schemaNames: action.payload,
            };
        case actionType.GET_ALL_REFDATAGOLDENEXPLORER_NAMES_SUCCESS:
            return {
                ...state,
                schemaNames: action.payload,
            };
        case actionType.GET_REFDATAGOLDENEXPLORER_RECORDS_SUCCESS: {
            const { tableName, columns, records, columnDefinitions, contextMenuItems } = action.payload;
            return {
                ...state,
                columnDefinitions,
                columns,
                tableName,
                records,
                contextMenuItems,
            };
        }
        case actionType.GET_REFDATAGOLDENEXPLORER_RECORDS_BY_ID_SUCCESS: {
            const { tableName, columns, records, columnDefinitions } = action.payload;
            const clientRecords = action.payload.records;
            const clientColumns = action.payload.columns;
            return {
                ...state,
                clientRecords,
                clientColumns,
            };
        }
        case actionType.ADD_API_LOGGERS: {
            const newLoggers = _cloneDeep(state.apiLoggers);
            newLoggers.push(action.payload);
            return {
                ...state,
                apiLoggers: newLoggers,
            };
        }
        case actionType.GET_SOURCE_SUMMARY_DATA: {
            return {
                ...state,
                sourceSummaryData: action.payload,
            };
        }
        case actionType.GET_GROUP_HISTORY_DATA: {
            return {
                ...state,
                groupHistoryData: action.payload,
            };
        }
        case actionType.GET_GROUP_LINEAGE_DATA: {
            return {
                ...state,
                groupLineageData: action.payload,
            };
        }
        case actionType.GET_LINKED_RECORDS: {
            return {
                ...state,
                linkedGroupDataRecords: action.payload,
            };
        }
        case actionType.GET_GROUP_GC_ID: {
            return {
                ...state,
                newGcIdForAdd: action.payload,
            };
        }
        case actionType.GET_SOURCE_DATA_RECORDS_SUCCESS:
            const { linkedData, proposedData } = action.payload;
            return {
                ...state,
                proposedMatchedRecords: _get(proposedData, 'records', []),
                linkedMatchedRecords: _get(linkedData, 'records', []),
                proposedMatchedGridOptions: {
                    defaultColDef: {
                        sortable: true,
                        filter: true,
                        resizable: true,
                        enableRowGroup: true,
                    },
                    columnDefs: _get(proposedData, 'columns', []),
                    enableRangeSelection: true,
                    animateRows: true,
                    allowContextMenuWithControlKey: true,
                    rowGroupPanelShow: 'always',
                },
                linkedMatchedGridOptions: {
                    defaultColDef: {
                        sortable: true,
                        filter: true,
                        resizable: true,
                        enableRowGroup: true,
                    },
                    columnDefs: _get(linkedData, 'columns', []),
                    enableRangeSelection: true,
                    animateRows: true,
                    allowContextMenuWithControlKey: true,
                    rowGroupPanelShow: 'always',
                },
            };

        case actionType.GET_SOURCE_DATA_CONTRIBUTION_SUCCESS:
            return {
                ...state,
                sourceConfigurationChartInfo: action.payload,
            };
        case actionType.GET_GC_HISTORIC_DATA:
            return {
                ...state,
                gcHistoricRecords: action.payload,
            };
        case actionType.GET_LINKED_GROUPS:
            return {
                ...state,
                linkedGroups: action.payload,
            };
        case actionType.CLEAN_LINKED_GROUPS:
            return {
                ...state,
                linkedGroups: [],
            };
        case actionType.GET_REF_DATA_LINKED_GROUP_RECORDS: {
            const { columns, records } = action.payload;
            return {
                ...state,
                linkedColumns: columns,
                linkedRowData: records,
            };
        }
        case actionType.GET_REF_DATA_LINKED_GROUP_RECORDS: {
            return {
                ...state,
                linkedColumns: [],
                linkedRowData: [],
            };
        }
        case actionType.GET_GC_PREVIOUS_DATA: {
            return {
                ...state,
                previousData: action.payload
            }
        }
        case actionType.GET_LINKED_DD_DATA: {
            return {
                ...state,
                linkedDDs: action.payload
            }
        }
        case actionType.GET_TRADES_CHARTS_DATA: {
            return {
                ...state,
                tradesChartData: action.payload
            }
        }
        default:
            return state;
    }
};

export default BLOCDATAEXPLORERReducer;
